import React, { useEffect, useState } from "react";
import BanqueService from "../../services/Banque";
import { useNavigate } from "react-router-dom";
import DataTableTransactions from "./DataTableTransactions";
import withLoader from "./../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

const TransactionsBankAccount = ({ startLoading, stopLoading }) => {
  const [banqueAccountInfo, setBanqueAccountInfo] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("bankAccountData")) || null; } catch { return null; }
  });
  const [listTransaction, setListTransaction] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [typeValidationPayement, setTypeValidationPayement] = useState("none");

  const [ss, setSs] = useState();
  const [sortie, setSortie] = useState(null);
  const [entree, setEntre] = useState(null);


  const [tt, setTt] = useState();
  const [se, setSe] = useState();

  const navigate = useNavigate();
  useEffect(() => {}, []);

  const onChangeDateBegin = (event) => {
    const date = new Date(event.target.value); // Parse the input date
    date.setHours(0, 0, 0, 0); // Set time to 00:00:00
    const formattedDate = formatDate(date); // Format the date
    setDateBegin(formattedDate);
    console.log(formattedDate)
  };

  const onChangeDateEnd = (event) => {
    const date = new Date(event.target.value); // Parse the input date
    date.setHours(23, 59, 59, 0); // Set time to 23:59:59
    const formattedDate = formatDate(date); // Format the date
    setDateEnd(formattedDate);
    console.log(formattedDate)

  };

  // Helper function to format date as "YYYY-MM-DDTHH:mm:ss"
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };



  const onGetDocumentsByFilter = () => {
    setListTransaction([]);
    startLoading();
    BanqueService.getListPayementsByBankAccountV2(
      sessionStorage.getItem("idBankAccount"),
      dateBegin,
      dateEnd,
      typeValidationPayement
    )
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setSe(response.data.se);
          setTt(response.data.tt);
          setSs(response.data.ss);
          setListTransaction(response.data.success);
        }
      })
      .catch(() => {
        console.log("error");
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetInformationsPaiement = () => {
    startLoading();
    SellingService.getListPayementsInformationsByBankAccount(
      getCurrentUserId(),
      sessionStorage.getItem("idBankAccount"),
      dateBegin,
      dateEnd,
      typeValidationPayement
    )
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setSortie(response.data.success.sortie)
          setEntre(response.data.success.entree)
        }
      })
      .catch(() => {
        console.log("error");
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setTypeValidationPayement(payement);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              {banqueAccountInfo && (
                <div style={{
                  background: "#111",
                  borderRadius: 6,
                  padding: "20px 28px",
                  marginTop: 16,
                  marginBottom: 16,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 16,
                  boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                    <div style={{
                      width: 52, height: 52, borderRadius: "50%",
                      background: "#fff", display: "flex", alignItems: "center",
                      justifyContent: "center", flexShrink: 0,
                    }}>
                      <i className="fas fa-university" style={{ fontSize: 22, color: "#111" }}></i>
                    </div>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "1.05rem", letterSpacing: 0.3 }}>
                        {banqueAccountInfo.name}
                      </div>
                      <div style={{ color: "#aaa", fontSize: "0.78rem", marginTop: 3 }}>
                        <i className="fas fa-credit-card mr-1"></i>
                        RIB : {banqueAccountInfo.rib}
                      </div>
                      <div style={{ color: "#aaa", fontSize: "0.78rem", marginTop: 2 }}>
                        <i className="fas fa-map-marker-alt mr-1"></i>
                        {banqueAccountInfo.agenceLocalisation}
                      </div>
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ color: "#aaa", fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: 1 }}>
                      Solde du compte
                    </div>
                    <div style={{
                      fontSize: "1.5rem", fontWeight: 800,
                      color: Number(banqueAccountInfo.solde) >= 0 ? "#69f0ae" : "#ff5252",
                      letterSpacing: 0.5,
                    }}>
                      {parseFloat(Number(banqueAccountInfo.solde).toFixed(3))} DNT
                    </div>
                    {se && <div style={{ fontSize: "0.78rem", color: "#aaa", marginTop: 4 }}>
                      Sortie: <strong style={{ color: "#ff5252" }}>{ss}</strong> &nbsp;|&nbsp;
                      Entrée: <strong style={{ color: "#69f0ae" }}>{se}</strong> &nbsp;|&nbsp;
                      Total: <strong style={{ color: "#fff" }}>{tt}</strong>
                    </div>}
                  </div>
                </div>
              )}

              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-4">
                      <label>Choisir état de transaction</label>

                      <select
                        class="form-control"
                        onChange={handleChangePayement}
                      >
                        <option key={1} value={"none"}>
                          Non rapproche
                        </option>
                        <option key={2} value={"accept"}>
                          Accépté
                        </option>
                        <option key={3} value={"refuse"}>
                          Rejeté
                        </option>
                        <option key={4} value={"refuse-def"}>
                          Rejeté définitivement
                        </option>
                      </select>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex">
                  <div className="col-sm-6  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetInformationsPaiement}
                    >
                      Informations de Paiement
                    </button>
                  </div>
                  <div className="col-sm-6  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetDocumentsByFilter}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
              {entree &&
                <div className="card-footer">
                  <div className=" my-2"><strong> Les Entrées</strong></div>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>

                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Espéce</span>
                        <span className="info-box-number">{entree?.eEspece}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>

                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">TPE</span>
                        <span className="info-box-number">{entree?.eEnligne}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Chéque</span>
                        <span className="info-box-number">{entree?.eChequeTraites}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Virement</span>
                        <span className="info-box-number">{entree?.eVirement}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Carte cadeau</span>
                        <span className="info-box-number">{entree?.eCarteCadeau}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {sortie &&
                <div className="card-footer">
                  <div className=" my-2"><strong>Les Sorties</strong></div>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>

                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Espéce</span>
                        <span className="info-box-number">{sortie?.sEspece}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>

                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">TPE</span>
                        <span className="info-box-number">{sortie?.sEnligne}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Chéque</span>
                        <span className="info-box-number">{sortie?.sChequeTraites}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Virement</span>
                        <span className="info-box-number">{sortie?.sVirement}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Carte cadeau</span>
                        <span className="info-box-number">{sortie?.sCarteCadeau}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}

              {listTransaction.length > 0 && (
                <DataTableTransactions listTransaction={listTransaction} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(TransactionsBankAccount);
